import { cache } from "react"

import http from "../../../../utils"
import { IUserInfo } from "./interface"

/**
 * 服务端获取用户信息
 * @returns 用户信息，如果未登录则返回 null
 */
export const getUserInfoServer = cache(async () => {
  const { cookies } = await import("next/headers")
  const cookieStore = await cookies()
  if (!process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY) {
    return null
  }
  const token = cookieStore.get(process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY)?.value
  return http.get<null, IUserInfo>(`/usercenter/en/get_english_user_info?auth_token=${token}`)
})
